import React, { Component } from 'react';
import HomeModule from './HomeModule'
import { Switch, Route } from 'react-router-dom';

class App extends Component {

    render() {
        return (
            <div>
                <Switch>
                    <Route exact path='/' component={HomeModule}/>
                    <Route path='/sucursal/:id' component={HomeModule}/>
                </Switch>
            </div>
        );
    }
    
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js